import { useMutation } from '@tanstack/react-query';

import type { Crm } from '../../../domain/crm';
import { useUseCases } from '../../../UseCaseProvider';

export const useExportAccountToCrmMutation = () => {
  const { exportAccountToCrm } = useUseCases();
  return useMutation({
    mutationKey: ['export-account-to-crm'],
    mutationFn: ({
      domain,
      crm,
      onSuccess,
      onError,
    }: {
      domain: string;
      crm: Crm;
      onSuccess?: () => void;
      onError?: () => void;
    }) => exportAccountToCrm({ domain, crm, onSuccess, onError }),
  });
};
